'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderErrorMessage = renderErrorMessage;

var _environment = require('./environment');

/**
 * Renders an error message and returns the HTML for that message.
 * @param {Error} err
 */
function renderErrorMessage(err, title) {
    var style = '';

    if (!(0, _environment.isInProductionMode)()) {
        var stack = !err.stack ? '' : err.stack.split('\n').map(function (s) {
            var parts = s.split('@');
            parts[0] = '<b>' + parts[0] + '</b>';
            return parts.join('&nbsp;@&nbsp;');
        }).join('\n');

        return '\n            ' + style + '\n            <div class="c-ff-hint c-ff-hint--warning">\n                <svg viewBox="0 0 24 24"><path d="M20.094 22.09H3.906a3.848 3.848 0 0 1-3.377-1.975 3.944 3.944 0 0 1 0-3.948L8.62 1.977C9.327.736 10.588 0 12 0s2.672.738 3.378 1.976l8.093 14.19a3.948 3.948 0 0 1 0 3.95 3.853 3.853 0 0 1-3.376 1.974zM12 1.136a2.744 2.744 0 0 0-2.407 1.408L1.5 16.736a2.812 2.812 0 0 0 0 2.814 2.748 2.748 0 0 0 2.406 1.408h16.188a2.749 2.749 0 0 0 2.407-1.408 2.812 2.812 0 0 0 0-2.814L14.408 2.54a2.747 2.747 0 0 0-2.407-1.404zM21.783 16.8L13.98 3.113c-.413-.726-1.153-1.158-1.98-1.158s-1.567.432-1.98 1.158L2.215 16.8a2.318 2.318 0 0 0 0 2.315 2.262 2.262 0 0 0 1.98 1.158h15.608c.826 0 1.567-.435 1.98-1.158a2.318 2.318 0 0 0 0-2.315zM10.588 7.384c0-.788.633-1.43 1.412-1.43.78 0 1.412.642 1.412 1.43v4.644c0 .788-.633 1.43-1.412 1.43-.78 0-1.412-.642-1.412-1.43V7.383zM12 17.678c-.8 0-1.45-.656-1.45-1.465 0-.81.65-1.47 1.45-1.47.8 0 1.448.66 1.448 1.47 0 .81-.65 1.465-1.448 1.465z"/></svg>\n                <div>\n                    <p><strong>' + (title || 'An error occurred') + '</strong></p>\n                    <p>' + err.message + '</p>\n                    <p>' + err.fileName + ':' + err.lineNumber + '</p>\n                    <pre>' + stack + '</pre>\n                </div>\n            </div>\n        ';
    }

    return '\n        ' + style + '\n        <div class="vue-component-error vue-component-error--production">\n            An error occurred\n        </div>';
}